import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

export const useAppDispatch = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const routeHistories = useSelector((state: any) => state.Common.routes);

  // Create a dispatch function that checks if we are on the last page
  const conditionalDispatch = (action: any) => {
    const path = `${location.pathname}${location.search || ""}`;
    const index = routeHistories.map((item: any) => item.path).indexOf(path);

    // if the index is -1 or the index is the last page
    const isExistPage = index === -1 || index === routeHistories.length - 1;

    if (isExistPage) {
      dispatch(action); // Dispatch only if it's the last page
    } else {
      console.log("Action not dispatched: Not on the last page.", action);
    }
  };

  return conditionalDispatch; // Return the conditional dispatch function
};
